// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* Sin scoped: los canvas se crean por código */\n.news-pdf__page {\n  display: block;\n  width: 100%;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.2);\n}\n", ""]);
// Exports
module.exports = exports;
